import axios from 'axios';

/**
 * 전체 유저에 대한 staking 정보 호출 (axios get)
 * @author ydw <teammapa.ydw@gmail.com>
 * @function _stakingInfo
 * @returns {object} staking.data
 */
export const _stakingInfo = async () => {
	try {
		const response = await axios.get(
			`${process.env.REACT_APP_BACKEND_API}/items/staking_info?fields=*.*`
		);
		return response.data;
	} catch (error) {
	} finally {
	}
};
/**
 * 전체 유저에 대한 staking 정보 호출 (axios post)
 * @author ydw <teammapa.ydw@gmail.com>
 * @function _stakingInfo
 * @returns {object} staking.data
 */

export const _postStakingInfo = async () => {
	try {
		const response = await axios.post(
			`${process.env.REACT_APP_BACKEND_API}/kct/staking_info`
		);
		return response.data;
	} catch (error) {
	} finally {
	}
};
